import {useCallback, useContext, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns} from '@s-ui/react-atom-button'
import AtomTooltip, {AtomTooltipPlacements} from '@s-ui/react-atom-tooltip'
import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline'

const BASE_CLASS = 'mt-BannerInfo'

const BannerInfo = ({icon = '📍', text, textMobile, tooltipTitle, tooltipBody, rounded}) => {
  const {i18n} = useContext(Context)
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)
  const isMobile = !useMediaQuery(useMediaQueryBreakpoints.md)

  const baseClassNames = cx(BASE_CLASS, {
    [`${BASE_CLASS}--rounded`]: rounded
  })

  const resolvedText = text ?? i18n.t('COMMON.DETAIL_CANARIAS_BANNER_TEXT')
  const resolvedTextMobile = textMobile ?? i18n.t('COMMON.DETAIL_CANARIAS_BANNER_TEXT_SHORT')
  const resolvedTooltipTitle = tooltipTitle ?? i18n.t('COMMON.DETAIL_CANARIAS_BANNER_TOOLTIP_TITLE')
  const resolvedTooltipBody = tooltipBody ?? i18n.t('COMMON.DETAIL_CANARIAS_BANNER_TOOLTIP_BODY')

  const handleButtonClick = useCallback(() => {
    setIsTooltipOpen(prev => !prev)
  }, [])

  const tooltipContent = (
    <div className={`${BASE_CLASS}-tooltipContent`}>
      <div className={`${BASE_CLASS}-tooltipHeader`}>
        <p className={`${BASE_CLASS}-tooltipTitle`}>{resolvedTooltipTitle}</p>
        <button
          className={`${BASE_CLASS}-tooltipCloseButton`}
          aria-label="Cerrar"
          type="button"
          onClick={() => setIsTooltipOpen(false)}
        >
          <IconClose aria-hidden role="presentation" size="medium" />
        </button>
      </div>
      <p className={`${BASE_CLASS}-tooltipBody`}>{resolvedTooltipBody}</p>
    </div>
  )

  return (
    <div className={baseClassNames}>
      {icon}
      <p className={`${BASE_CLASS}-text`}>{isMobile ? resolvedTextMobile : resolvedText}</p>
      <AtomTooltip
        placement={AtomTooltipPlacements.TOP_END}
        color="neutral"
        isArrowed={false}
        content={tooltipContent}
        isVisible={isTooltipOpen}
      >
        <AtomButton
          aria-label={resolvedTooltipTitle}
          aria-expanded={isTooltipOpen}
          design={atomButtonDesigns.FLAT}
          isFitted
          onClick={handleButtonClick}
        >
          <IconInfoOutline aria-hidden role="presentation" size="small" />
        </AtomButton>
      </AtomTooltip>
    </div>
  )
}

BannerInfo.displayName = 'BannerInfo'

BannerInfo.propTypes = {
  icon: PropTypes.node,
  text: PropTypes.string,
  textMobile: PropTypes.string,
  tooltipTitle: PropTypes.string,
  tooltipBody: PropTypes.string,
  rounded: PropTypes.bool
}

export default BannerInfo
